import { Maybe, InvoiceType } from 'schema'
import compact from 'lodash/compact'
import isNil from 'lodash/isNil'
import formatNumber from './formatNumber'

const formatCurrency = (value: Maybe<number> | undefined, currency?: string): string =>
  compact([currency, typeof value === 'number' ? formatNumber(value) : '-']).join(' ')

export const formatCurrencyEnd = (value: Maybe<number> | undefined, currency?: string): string =>
  compact([typeof value === 'number' ? formatNumber(value) : '-', currency]).join(' ')

export const formatCurrencyWithInvoiceType = (value: Maybe<number> | undefined, invoiceType: InvoiceType): string => {
  const finalValue = isNil(value) ? 0.0 : value

  return formatCurrency(invoiceType === InvoiceType.CreditNote ? -1 * finalValue : finalValue)
}

export const formatSimpleCurrencyValue = (value: Maybe<number> | undefined): number => {
  let res = 0

  if (!isNil(value)) {
    if (typeof value === 'number') {
      res = parseFloat(value.toFixed(2).replace(/(\.0+|0+)$/, ''))
    } else if (typeof value === 'string') {
      res = parseFloat(
        parseFloat(value)
          .toFixed(2)
          .replace(/(\.0+|0+)$/, '')
      )
    }
  }

  return res
}

export default formatCurrency
